/* eslint-disable no-shadow */
/* eslint-disable react/display-name */
import React, { FC, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import EmptyCampaignTemplatesPage from "../../components/CampaignCreation/EmptyCampaignTemplatesPage";
import Loader from "../../components/elements/Loader";
import PageLayout from "../../layouts/PageLayout";
import TemplateCard from "./TemplateCard";
import api from "../../api";
import classes from "./CampaignTemplatesPage.module.scss";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const CampaignTemplatesPage: FC = () => {
  const user = useSelector((state: ReduxApplicationState) => state.user.currentUser);
  const [templates, setTemplates] = useState<any[]>([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);

  const fetchTemplates = useCallback(async () => {
    try {
      setIsLoadingTemplates(true);
      const data = await api.getCampaignTemplatesByUser(user);
      setTemplates(data);
      setIsLoadingTemplates(false);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
      setIsLoadingTemplates(false);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;

    fetchTemplates();
  }, [fetchTemplates, user]);

  return !templates || isLoadingTemplates ? (
    <Loader />
  ) : templates.length !== 0 ? (
    <PageLayout heading="Manage Campaign Templates">
      <div className={classes.customSlideOptionsContainer}>
        {templates.map((template) => (
          <TemplateCard key={template.id} template={template} fetchTemplates={fetchTemplates} />
        ))}
      </div>
    </PageLayout>
  ) : (
    <EmptyCampaignTemplatesPage />
  );
};

export default CampaignTemplatesPage;
